import * as React from 'react';
import {
    Chart,
    ChartLegend,
    ChartSeries,
    ChartSeriesItem,
    ChartCategoryAxis,
    ChartCategoryAxisItem,
    ChartValueAxis,
    ChartValueAxisItem, ChartArea
} from '@progress/kendo-react-charts';

const EnergyJuniorStaffingIndexChart = React.memo(({ energyJuniorStaffingIndexData, chartRef }) => {
    const categories = energyJuniorStaffingIndexData.ChartData.Dates;
    const axisLabelStyle = {
        color: '#424242',
        font: '12px Segoe UI, sans-serif',
    };
    const baseLabels = {
        visible: true,
        font: '10px Segoe UI, sans-serif',
        color: '#fff',
        opacity: 1
    };

    return (
        <Chart ref={chartRef} style={{ height: 500 }} >
            <ChartArea margin={20} />
            <ChartLegend position="bottom"
                item={{ visual: undefined, cursor: 'default', highlight: { visible: false } }}
                orientation="horizontal"
                labels={{ font: '12px Segoe UI, sans-serif', color: '#323130' }} />
            <ChartValueAxis>
                <ChartValueAxisItem
                    title={{
                        text: 'Index',
                        font: '12px bold Segoe UI, sans-serif',
                        color: '#323130',
                    }}
                    labels={{ format: '{0}' }}
                />
            </ChartValueAxis>
            <ChartCategoryAxis>
                <ChartCategoryAxisItem majorGridLines={{ visible: false }} labels={axisLabelStyle} categories={categories} />
            </ChartCategoryAxis>

            <ChartSeries>
                <ChartSeriesItem
                    labels={{ ...baseLabels, background: '#002750' }}
                    color="#002750"
                    type="line"
                    data={energyJuniorStaffingIndexData.ChartData.EstimatedIndex}
                    name="Estimated Index"
                    legendItem={{
                        markers: { visible: false }, type: 'area'
                    }}
                    tooltip={{
                        visible: true
                    }} />
                <ChartSeriesItem
                    labels={{ ...baseLabels, background: '#73b0e3' }}
                    color="#73b0e3"
                    type="line"
                    data={energyJuniorStaffingIndexData.ChartData.ReportedIndex}
                    name="Reported Index"
                    legendItem={{
                        markers: { visible: false }, type: 'area'
                    }}
                    tooltip={{
                        visible: true
                    }} />

            </ChartSeries>
        </Chart>
    );
});

export default EnergyJuniorStaffingIndexChart;